(function () {
  function setOpen(wrapper, open) {
    var toggle = wrapper.querySelector('[data-read-more-toggle]');
    wrapper.classList.toggle('read-more--open', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? wrapper.dataset.less : wrapper.dataset.more;
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-read-more-toggle]');
    if (!toggle) return;
    var wrapper = toggle.closest('[data-read-more]');
    if (!wrapper) return;
    event.preventDefault();
    setOpen(wrapper, !wrapper.classList.contains('read-more--open'));
  });

  function checkAll() {
    document.querySelectorAll('[data-read-more]').forEach(function (wrapper) {
      if (wrapper.classList.contains('read-more--open')) return;
      var content = wrapper.querySelector('[data-read-more-content]');
      if (!content) return;

      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var name = isDesktop ? '--read-more-height' : '--read-more-height-mobile';
      var limit = parseFloat(getComputedStyle(wrapper).getPropertyValue(name)) || (isDesktop ? 400 : 280);

      wrapper.classList.toggle('read-more--short', content.scrollHeight <= limit + 24);
    });
  }

  document.addEventListener('DOMContentLoaded', checkAll);
  window.addEventListener('load', checkAll);
  window.addEventListener('resize', checkAll);
  document.addEventListener('shopify:section:load', checkAll);
  checkAll();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      var wrapper = event.target.closest('[data-read-more]');
      if (wrapper) setOpen(wrapper, true);
    });
  }
})();